import React from 'react';
import '../styles/STPStatusBadge.css';

const LABELS = {
  NOT_SUBMITTED: 'Not Submitted',
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  FAILED: 'Failed',
};

export default function STPStatusBadge({ status }) {
  const key = status || 'NOT_SUBMITTED';
  const label = LABELS[key] || LABELS.NOT_SUBMITTED;
  const cls = `stp-status-badge stp-status-badge--${String(key).toLowerCase()}`;
  return <span className={cls}>{label}</span>;
}

